import { ITheme } from 'application/utils/type'
export const theme: ITheme = {
  brand: 'Maxxia',
  //media queries should match bootstrap media queries
  mq: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  colors: {
    primary: '#d14200',
    primaryButtonHover: '#ad240a',
    buttonDisabled: '#545454',
    secondary: '#ad240a',
    textDarkblack: '#000',
    textLightblack: '#333',
    positive: '#3ba933',
    positive2: '#216039',
    positive3: '#247f38',
    primaryLightText: '#f7f7f7',
    secondaryLightText: '#999',
    spartaGreen: '#247F38',
    spartaGreen2: '#DBFBD9',
    secondaryHeading: '#00b5cc',
    borderColor: '#ccc',
    grey2: '#666',
    linkColor: '#333',
    yield: '#666',
    lightBackground: '#f7f7f7',
    white: '#fff',
    navColor: '#666',
    footerText: '#a2a2a2',
    alertGreen: '#247F38',
    alertGreen2: '#DBFBD9',
    alertGrey: '#939598',
    warning2: '#FFF8E9',
    warning: '#906A1D',
    warningContrast: '#654F0D',
    alertRed: '#721c24',
    shadowColour: '#3031331a',
    cardHeaderFontColor: '#666',
    danger: '#c20000',
    boxShadow: '#f2f2f2',
    bannerSectionContentColor: '#f2f2f2',
  },
  backgrounds: {
    backGround1: '#fff',
    backGround2: '#e6e6e6',
    backGround3: '#f7f7f7',
  },
  font: {
    weight: {
      normal: 500,
      slightBold: 600,
      semiBold: 800,
      bold: 900,
    },
    size: {
      smaller: '14px',
      small: '16px',
      medium: '18px',
      larger: '24px',
      largest: '36px',
    },
    caption: {
      fontSize: '18px',
    },
    primaryButton: {
      fontSize: '16px',
    },
    text: {
      fontSize: '18px',
    },
  },
  other: {
    primaryButton: {
      borderRadius: '40.5px',
      fontWeight: 600,
      fontSize: '21px',
    },
  },
}
